import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-pays-first",
    prompt: "If a member has both an FSA and an HRA, and a transaction is eligible under both plans, one of the accounts must be selected to be used first. Select whether participant transactions will be paid first from their FSA or HRA. Click Save.",
    briefDescription: 'FSA/HRA Pays First',
    openAction: {
        text: "Where to set if FSA or HRA pays first?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Pays First" 
    },
    completeAction: {
    },
});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-pays-first.js